PJQ.views.actionItems.ActionItemView = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ACTIONITEMS, 'Action-Item-Management'),
        actionItemId: null
    },
    events: {
        'click .btn-action-item-settings': 'viewActionItemSettings',
        'click .export-detailed': 'exportDetailedList',
        'click .export-list': 'exportList',
        'click .btn-add-action-item': 'addClicked',
        'click .btn-edit-action-item': 'editClicked',
        'click .btn-delete-action-item': 'deleteClicked',
        'click .btn-save-a-template': 'saveTemplate',
        'click .btn-import-template': 'importTemplate'
    },
    beforeFirstRender: function () {
        this.options.isAdmin = true;
        if (PJQ.app.session.project != null) {
            this.options.isAdmin = (PJQ.app.session.user != null && PJQ.app.session.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')) && this.options.project.hasPermission('actionItems.isAdmin');
        }

        this.isFetched = false;
        this.preferences = this.options.project ? this.options.project.preferences : PJQ.app.session.preferences;
        this.options.userSettings = new PJQ.models.actionItems.ActionItemUserSettings();
        let fnFetch = _.bind(function () {
            this.options.userSettings.fetch({
                success: _.bind(function () {
                    let fnRender = _.bind(function (customFields) {
                        this.options.customFields = customFields;
                        if (this.collection == null && this.options.project != null) {
                            let actionItems = new PJQ.collections.actionItems.ActionItems(null, {
                                project: this.options.project
                            });
                            actionItems.fetch({
                                success: _.bind(function () {
                                    this.collection = actionItems;
                                    this.isFetched = true;
                                    this.render();
                                }, this)
                            });
                            return false;
                        } else {
                            this.isFetched = true;
                            this.render();
                        }
                    }, this);
                    if (this.options.project != null) {
                        this.options.project.fetchActionItemCustomFields(_.bind(function (customFields) {
                            fnRender(customFields);
                        }, this));
                    } else {
                        PJQ.app.session.fetchActionItemCustomFields(null, _.bind(function (customFields) {
                            fnRender(customFields);
                        }, this));
                    }
                }, this)
            });
        }, this)

        if (this.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
            this.options.project.fetchLocations(_.bind(function (locations) {
                this.locations = locations;
                fnFetch();
            }, this));
        } else {
            fnFetch();
        }
    },
    renderData: function () {
        return {
            project: this.options.project
        };
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderDataTable();

        //If there was a passed in item to be shown (for a route), show it now
        if (this.options.actionItemId > 0) {
            let item = this.collection.get(this.options.actionItemId);
            this.options.actionItemId = null;
            if (item != null) {
                this.editActionItem(item);
            }
        }
    },
    renderDataTable() {
        let self = this,
            userSettings = this.options.userSettings.getSettings(PJQ.constants.actionItems.view.ACTIONITEMS);
        this.actionItemDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.action-items'),
            rowId: "cid",
            data: this.collection.models,
            language: {
                emptyTable: 'Click "Add Item" to create an Action Item',
                zeroRecords: "No items matched the search criteria"
            },
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.ACTIONITEMS, 'Data-Table-Header-Action-Items')
            },
            pageLength: userSettings != null ? userSettings.rowsPerPage : 50,
            orderCookie: PJQ.constants.cookies.ACTION_ITEM_ORDER_COOKIE,
            settings: this.options.userSettings.getSettings(PJQ.constants.actionItems.view.ACTIONITEMS),
            headerData: function () {
                return {
                    project: self.options.project,
                    preferences: self.preferences
                };
            },
            afterHeaderRender: _.bind(function (view, $header) {
                new PJQ.inputs.Selectpicker({
                    el: $header.find('.action-item-filter'),
                    onChange: function (value) {
                        view.setFilter('primary', value);
                    },
                    isGrouped: true,
                    isIntChoices: true,
                    isMultiple: true,
                    noneSelectedText: 'No Filters'
                });

                if (this.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
                    this.locationFilterPicker = new PJQ.inputs.ProjectLocationPicker({
                        el: this.$('.filter-location'),
                        project: this.options.project,
                        isMultiple: true,
                        onChange: _.bind(function (value) {
                            view.setFilter('location', value);
                        }, this)
                    });
                }
            }, this),
            getFilterData: function (view, data) {
                let result = data,
                    locationFilter = view.getFilter('location');
                if (_.size(locationFilter) > 0) {
                    result = _.filter(data, function (row) {
                        return _.contains(locationFilter, row.get('locationId'));
                    }, this);
                }

                let primaryFilter = view.getFilter('primary');
                if (_.size(primaryFilter) === 0) {
                    return result;
                }

                let statusFilter = primaryFilter.status,
                    priorityFilter = primaryFilter.priority,
                    hasAssigned = _.contains(statusFilter, PJQ.constants.actionItems.statuses.ASSIGNED);
                return _.filter(result, function (row) {
                    let rowStatus = row.get('status');
                    return (_.size(priorityFilter) === 0 || _.contains(priorityFilter, row.get('priority')))
                        && (_.size(statusFilter) === 0 || (hasAssigned && rowStatus === PJQ.constants.actionItems.statuses.NEW && row.assignedTo != null) || _.contains(statusFilter, rowStatus));
                });
            },
            order: [[0, "asc"]],
            deferRender: true,
            onRowDoubleClick: _.bind(function (row) {
                this.editActionItem(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editActionItem(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: _.bind(function () {
                            return this.options.isAdmin;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.deleteActionItem(row);
                        }, this)
                    }
                ]
            },
            columns: this.getColumns(false),
            colReorder: {
                fixedColumnsLeft: 0,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: _.bind(function () {
                if (this.options.userSettings != null) {
                    this.options.userSettings.save();
                }
            }, this)
        });
    },
    getColumns(includeAllColumns = false) {
        let columns = [], includeColumns = [],
            viewSettings = this.options.userSettings.getSettings(PJQ.constants.actionItems.view.ACTIONITEMS);

        if (includeAllColumns || viewSettings == null) {
            includeColumns = ["createdBy", "status", "priority", "itemNumber", "title", "assignedTo", "ballInCourt", "groupList", "category", "location", "dueDate"];

            if (_.size(this.options.customFields) > 0) {
                _.each(this.options.customFields.models, function (customField) {
                    includeColumns.push('fieldValue' + customField.get('fieldNumber'));
                });
            }
        } else
            includeColumns = viewSettings.columns;

        _.each(includeColumns, _.bind(function (column) {
                switch (column) {
                    case "createdBy":
                        columns.push({
                            columnData: 'createdBy',
                            title: "Created By",
                            render: function (data, type, row) {
                                return PJQ.helpers.contacts.getContactAnchor({contact: row.createdBy});
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : false
                        });
                        break;
                    case "status":
                        columns.push({
                            columnData: "status",
                            data: "attributes.status",
                            title: "Status",
                            width: "80px",
                            render: function (data, type, row) {
                                return '<span style="color:' + row.getStatusColor() + '">' + row.getStatusName() + '</span>';
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "priority":
                        columns.push({
                            columnData: "priority",
                            data: "attributes.priority",
                            title: "Priority",
                            width: "40px",
                            render: function (data, type, row) {
                                return '<span style="color:' + row.getPriorityColor() + '">' + row.getPriorityName() + '</span>';
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "itemNumber":
                        columns.push({
                            columnData: "itemNumber",
                            data: {
                                "_": "attributes.itemNumber",
                                "sort": _.bind(function (row) {
                                    let numStr = row.get('itemNumber');
                                    if (_.size(numStr) > 0) {
                                        let number = parseInt(numStr);
                                        if (isNaN(number)) {
                                            return numStr;
                                        }
                                        return number
                                    }
                                    return 0;
                                }, this),
                                "display": "attributes.itemNumber"
                            },
                            title: "Item #",
                            width: "60px",
                            type: "natural-ci",
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "title":
                        columns.push({
                            columnData: "title",
                            data: "attributes.title",
                            title: "Title",
                            width: "20%",
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "assignedTo":
                        columns.push({
                            columnData: "assignedTo",
                            data: "attributes.assignedTo",
                            title: "Assigned To",
                            render: function (data, type, row) {
                                let result = 'Nobody';
                                if (row.assignedTo) {
                                    result = PJQ.helpers.contacts.getContactAnchor({contact: row.assignedTo});
                                }
                                return result;
                            },
                            width: "20%",
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "ballInCourt":
                        columns.push({
                            columnData: "ballInCourt",
                            title: "Ball In Court",
                            render: function (data, type, row) {
                                let result = 'Nobody';

                                if ((row.get('status') === PJQ.constants.actionItems.statuses.NEW || row.get('status') === PJQ.constants.actionItems.statuses.NOT_RESOLVED) && row.assignedTo != null) {
                                    result = PJQ.helpers.contacts.getContactAnchor({contact: row.assignedTo});
                                } else if (row.get('status') === PJQ.constants.actionItems.statuses.WORK_COMPLETED) {
                                    result = 'Project Managers';
                                }

                                return result;
                            },
                            width: "20%",
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : false
                        });
                        break;
                    case 'groupList':
                        columns.push({
                            columnData: 'groupList',
                            title: "Trades",
                            render: function (data, type, row) {
                                let result = [];
                                if (_.size(row.groups.models) > 0) {
                                    _.each(row.groups.models, function (group) {
                                        result.push(group.get('groupName'));
                                    });
                                } else {
                                    result.push('None');
                                }
                                return result.join(', ');
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : false
                        });
                        break;
                    case 'category':
                        columns.push({
                            columnData: 'category',
                            data: "attributes.category",
                            title: "Category",
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : false
                        });
                        break;
                    case 'location':
                        columns.push({
                            columnData: 'location',
                            data: "attributes.location",
                            title: "Location",
                            render: _.bind(function (data, type, row) {
                                if (this.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
                                    let location = this.locations.get(row.get('locationId'));
                                    return location ? this.locations.getFullName(location) : '';
                                }
                                return typeof data === 'string' ? data : '';
                            }, this),
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : false
                        });
                        break;
                    case "dueDate":
                        columns.push({
                            columnData: "dueDate",
                            "data": "attributes.dueDate",
                            "title": "Due",
                            "searchable": false,
                            "width": "80px",
                            "render": function (data, type, row) {
                                if (data != null) {
                                    let itemDueDate = new Date(data),
                                        dateString = PJQ.helpers.dateHelpers.getDateString(itemDueDate, PJQ.helpers.dateHelpers.dateFormats.DATE);
                                    if (row.get('status') !== PJQ.constants.actionItems.statuses.RESOLVED && PJQ.helpers.dateHelpers.getDateDaysDiff(itemDueDate, new Date()) < 0) {
                                        return '<span class="text-danger font-weight-bold">' + dateString + '</span>';
                                    }
                                    return dateString;
                                }
                                return 'Not Set';
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    default:
                        if (column.startsWith('fieldValue')) {
                            _.each(this.options.customFields.models, function (customField) {
                                if (column === 'fieldValue' + customField.get('fieldNumber')) {
                                    columns.push({
                                        "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                        "title": customField.get('fieldName'),
                                        "className": [PJQ.constants.commitments.customFieldType.INTEGER, PJQ.constants.commitments.customFieldType.MONEY, PJQ.constants.commitments.customFieldType.PERCENT].indexOf(customField.get('fieldTypeId')) !== -1 ? "text-align-right" : "",
                                        'visible': viewSettings.columns.indexOf(column) !== -1,
                                        "render": function (data, type, row) {
                                            let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                            fieldValue = (fieldValue !== null) ? fieldValue : '';
                                            switch (customField.get('fieldType')) {
                                                case PJQ.constants.customFields.fieldTypes.TEXT:
                                                    if (fieldValue && type !== 'sort' && type !== 'type') {
                                                        if (PJQ.helpers.urlHelpers.isURL(fieldValue))
                                                            fieldValue = '<a target="_blank" href="' + fieldValue + '">' + fieldValue + '</a>';
                                                    }
                                                    break
                                                case 'BOOL':
                                                    if (fieldValue != null)
                                                        fieldValue = fieldValue ? 'Yes' : 'No';
                                                    break;
                                                case 'CHOICE':
                                                    let choices = [];
                                                    // convert single choice value into array so that the logic below can work for both types.
                                                    if (typeof fieldValue === 'number')
                                                        fieldValue = [fieldValue];

                                                    _.each(customField.choices.models, _.bind(function (choice) {
                                                        if (_.find(fieldValue, function (value) {
                                                            return value === choice.get('id');
                                                        }))
                                                            choices.push(choice.get('choiceName'));
                                                    }, this));

                                                    fieldValue = choices.join((', '));
                                                    break;
                                                case 'DATE':
                                                    if (fieldValue) {
                                                        if (type !== 'sort' && type !== 'type')
                                                            fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                    }
                                                    if (fieldValue === undefined)
                                                        fieldValue = '';

                                                    break;
                                                case 'DATETIME':
                                                    if (fieldValue) {
                                                        if (type !== 'sort' && type !== 'type')
                                                            fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, false);
                                                    }
                                                    if (fieldValue === undefined)
                                                        fieldValue = '';

                                                    break;
                                                case 'INT':
                                                    if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                        fieldValue = parseInt(fieldValue).toLocaleString();
                                                    }
                                                    break;
                                                case 'MONEY':
                                                    if (type === 'sort' || type === 'type') {
                                                        if (fieldValue && fieldValue !== '$')
                                                            fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                        else
                                                            fieldValue = 0;
                                                    } else {
                                                        fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                    }
                                                    break;
                                                case 'PERCENT':
                                                    if (type === 'sort' || type === 'type') {
                                                        if (!fieldValue)
                                                            fieldValue = 0;
                                                    } else {
                                                        fieldValue = fieldValue ? PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)), 2, false) + '%' : '';
                                                    }
                                                    break;
                                            }

                                            return fieldValue;
                                        }
                                    });
                                }
                            });
                        }
                        break;
                }
            }, this)
        );

        if (!includeAllColumns) {
            columns.push({
                columnData: "actionItemId",
                data: "attributes.actionItemId",
                title: "",
                width: '80px',
                orderable: false,
                searchable: false,
                className: 'text-align-center',
                render: _.bind(function (data) {
                    let html = '<div class="show-on-row-hover"><button type="button" data-action-item-id="' + data + '" class="btn btn-info btn-edit-action-item"><i class="fal fa-pencil"></i></button>';
                    if (this.options.isAdmin) {
                        html += '<button type="button" data-action-item-id="' + data + '" class="btn btn-danger btn-delete-action-item ml-1"><i class="fal fa-trash"></i></button>';
                    }
                    html += '</div>';
                    return html;
                }, this)
            });
        }

        return columns;
    },
    addClicked() {
        let newItem = new PJQ.models.actionItems.ActionItem({
            projectId: PJQ.app.session.project ? PJQ.app.session.project.id : null,
            templateId: this.model != null ? this.model.get('templateId') : null
        });
        this.editActionItem(newItem);
    },
    editClicked(e) {
        let row = this.actionItemDataTable.getRow($(e.currentTarget).parents('tr'));
        this.editActionItem(row.data());
    },
    editActionItem: function (item) {
        let isNew = item.isNew();
        let fnRenderEditor = _.bind(function () {
            new PJQ.views.actionItems.ActionItemEditorModal({
                model: item,
                collection: this.collection,
                project: this.options.project,
                onSave: _.bind(function (item) {
                    if (isNew) {
                        this.actionItemDataTable.addRow(item);
                        this.collection.add(item);
                    }
                    this.actionItemDataTable.refresh();
                }, this),
                onClose: _.bind(function (item) {
                    if (item.hasChanged()) {
                        item.restore();
                    }
                }, this),
                onDelete: _.bind(function (item) {
                    if (item.id > 0) {
                        let row = this.actionItemDataTable.getRow(item.cid);
                        if (row != null) {
                            this.actionItemDataTable.removeRow(row);
                        }
                    }
                    item.destroy();
                }, this)
            });
        }, this)
        if (!item.isNew()) {
            item.fetch({
                success: _.bind(function () {
                    fnRenderEditor();
                }, this)
            });
        } else {
            fnRenderEditor();
        }
    },
    deleteClicked(e) {
        let row = this.actionItemDataTable.getRow($(e.currentTarget).parents('tr'));
        this.deleteActionItem(row);
    },
    deleteActionItem: function (row) {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this action item?",
            onDelete: _.bind(function () {
                row.data().destroy();
                this.actionItemDataTable.removeRow(row);
            }, this)
        });
    },
    exportList: function () {
        if (this.options.project == null) {
            return;
        }

        let orderCookie = PJQ.helpers.cookieHelpers.getCookie(PJQ.constants.cookies.ACTION_ITEM_ORDER_COOKIE),
            order = orderCookie != null ? JSON.parse(orderCookie) : null,
            report = new PJQ.models.reports.NewReport({
                type: PJQ.constants.reports.reportTypes.ACTION_ITEM.type,
                projectId: this.options.project ? this.options.project.id : null,
                options: {
                    columns: this.options.userSettings.getSettings(PJQ.constants.actionItems.view.ACTIONITEMS).columns,
                    columnOrder: order
                }
            });
        report.export({format: 'excel'}).then(() => {

        });
    },
    exportDetailedList: function () {
        if (this.options.project == null) {
            return;
        }

        let params = [
                {
                    parameter: 'orderBy',
                    value: this.actionItemDataTable.options.settings.orderBy
                },
                {
                    parameter: 'orderAscending',
                    value: this.actionItemDataTable.options.settings.orderAscending
                }
            ],
            filterData = this.actionItemDataTable.getFilteredRowData();
        if (_.size(filterData) < _.size(this.collection.models)) {
            params.push(
                {
                    parameter: 'ids',
                    value: _.map(filterData, function (item) {
                        return item.id;
                    })
                }
            );
        }

        let loader = new PJQ.Loader(this.$('.btn-export'), {
            loadingText: ""
        });
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'actionitems',
                },
                {
                    endpoint: 'export'
                },
                {
                    endpoint: 'detailed'
                }
            ], params),
            data: {
                itemOrder: _.map(filterData, (item) => {
                    return item.id
                })
            }
        }).post().done(_.bind(function (response) {
            PJQ.files.handleDownload(response);
            loader.remove();
        }, this)).fail(_.bind(function (xhr, err, result) {
            loader.remove();
        }, this));
    },
    viewActionItemSettings: function () {
        new PJQ.views.actionItems.ActionItemSettingsModal({
            actionItemsView: this,
            project: this.options.project,
            userSettings: this.options.userSettings,
            onSave: _.bind(function () {
                this.renderDataTable();
            }, this)
        });
    },
    saveTemplate: function () {
        new PJQ.views.actionItems.ActionItemTemplateCreatorModal({
            collection: this.collection,
            project: this.options.project
        });
    },
    importTemplate: function () {
        new PJQ.views.actionItems.ImportTemplateModal({
            project: this.options.project,
            onImport: _.bind(function (submittals) {
                this.collection = submittals;
                this.render();
            }, this)
        });
    },
});

PJQ.views.actionItems.ActionItemEditorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ACTIONITEMS, 'Modal-Action-Item-Editor'),
        subTemplates: {
            comments: new PJQ.templating.Template(PJQ.constants.modules.ACTIONITEMS, 'Action-Item-Comments'),
            contactBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Select-Input-Contacts')
        },
        width: '90%',
        maxWidth: 1200,
        isShowCloseButton: true,
        onSave: _.noop
    },
    events: {
        'click .add-comment': 'addComment',
        'click .item-cancel': 'cancel',
        'click .edit-history': 'viewEditHistory',
        'click .btn-notification-history': 'viewNotificationHistory',
        'click .btn-export': 'exportPDF',
        'click .item-status-not-resolved': 'markNotResolved',
        'click .item-status-work-completed': 'markWorkCompleted',
        'click .item-status-resolved': 'markResolved',
        'click .action-item-save': 'save',
        'click .action-item-close': 'close',
        'click .action-item-delete': 'onDelete',
        'click .delete-comment': 'deleteComment',
        'click .btn-distribute': 'distribute'
    },
    beforeModalCreated: function () {
        this.preferences = this.options.project ? this.options.project.preferences : PJQ.app.session.preferences;
        this.options.canEdit = true;
        this.options.canUpload = true;
        this.options.isAdmin = true;

        let isAssignee = this.model.get('isAssignee') || (this.model.assignedTo != null && (PJQ.app.session.contact != null && this.model.assignedTo.id === PJQ.app.session.contact.id || PJQ.app.session.user != null && this.model.assignedTo.id === PJQ.app.session.user.get('id')));
        if (this.options.project != null) {
            this.options.canEdit = this.model.isNew() || this.options.project.hasPermission('actionItems.isAdmin') && this.model.get('status') !== PJQ.constants.actionItems.statuses.RESOLVED;
            this.options.canUpload = this.options.canEdit || isAssignee;
            this.options.isAdmin = PJQ.app.session.user != null && this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId') && this.options.project.hasPermission('actionItems.isAdmin');
        }

        this.changedAnnotations = new PJQ.collections.drawings.Annotations();
    },
    renderData: function () {
        return {
            canEdit: this.options.canEdit,
            canUpload: this.options.canUpload,
            isAdmin: this.options.isAdmin,
            model: this.model,
            preferences: this.preferences
        };
    },
    afterRender: function () {
        if (this.model) {
            if (this.options.canEdit) {
                new PJQ.Binder(this.$el, this.model, {
                    watchElements: [
                        'input',
                        'textarea'
                    ]
                });
            }

            new PJQ.inputs.Datepicker({
                el: this.$('.action-item-due-date'),
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('dueDate')
                },
                onChange: _.bind(function (newDate) {
                    let currentDueDate = this.model.get('dueDate');
                    if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                        this.model.set('dueDate', newDate);
                    }
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: this.$('.action-item-priority'),
                isIntChoices: true,
                onChange: _.bind(function (value) {
                    this.model.set('priority', value);
                }, this),
                defaultValue: this.model.get('priority')
            });

            if (this.options.canEdit) {
                new PJQ.inputs.AutocompleteInput({
                    el: this.$('input.item-category'),
                    source: this.collection == null ? [] : _.map(_.filter(this.collection.models, _.bind(function (item) {
                        return _.size(item.get('category')) > 0 && item.id !== this.model.id;
                    }, this)), function (item) {
                        return item.get('category');
                    })
                });
            }

            if (this.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
                new PJQ.inputs.ProjectLocationPicker({
                    el: this.$('.select-location'),
                    project: this.options.project,
                    canEdit: this.options.canEdit,
                    onChange: _.bind(function (value) {
                        this.model.set('locationId', value);
                    }, this),
                    defaultValue: this.model.get('locationId')
                });
            } else {
                new PJQ.inputs.AutocompleteInput({
                    el: this.$('input.item-location'),
                    source: this.collection == null ? [] : _.map(_.filter(this.collection.models, _.bind(function (item) {
                        return _.size(item.get('location')) > 0 && item.id !== this.model.id;
                    }, this)), function (item) {
                        return item.get('location');
                    })
                });
            }

            this.renderBallInCourt();

            if (PJQ.app.session.project != null) {
                PJQ.app.session.project.fetchActionItemCustomFields(_.bind(function (customFields) {
                    this.customFields = customFields;
                    this.renderCustomFields();
                }, this));
            } else {
                PJQ.app.session.fetchActionItemCustomFields(_.bind(function (customFields) {
                    this.customFields = customFields;
                    this.renderCustomFields();
                }, this));
            }

            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.action-item-assigned'),
                context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                selectedContact: this.model.assignedTo,
                isSingleChoice: true,
                isReadOnly: !this.options.canEdit || !this.options.isAdmin,
                onChange: _.bind(function (selectedContact) {
                    this.model.assignedTo = selectedContact;
                    this.renderBallInCourt();
                    this.renderStatus();
                }, this)
            });

            if (this.options.isAdmin) {
                new PJQ.views.contacts.ContactsSelectInput({
                    el: this.$('.action-item-distribution-list'),
                    selectedContact: this.model.distributionList.models,
                    canViewContacts: this.options.project == null || this.options.project.hasPermission('projectContacts.canView'),
                    canEdit: this.options.canEditPeople,
                    displayContactsBlock: true,
                    canSwitchContext: this.options.project == null,
                    context: this.options.project != null ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
                    isSingleChoice: false,
                    onChange: _.bind(function (selectedContacts) {
                        this.model.distributionList.reset(selectedContacts);
                        this.model.isDirty = true;
                    }, this)
                });
            }

            this.groupListInput = new PJQ.views.groups.GroupsSelectInput({
                el: this.$('.action-item-groups'),
                isShowAddButton: false,
                addButton: this.$('.btn-edit-groups'),
                groupLevels: PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS),
                groupUserId: this.options.project ? this.options.project.get('masterUserId') : null,
                selectedGroups: this.model.groups.models,
                isReadOnly: !this.options.canEdit,
                onAfterSave: _.bind(function (selectedGroups) {
                    this.model.groups.reset(selectedGroups);
                    this.model.isDirty = true;
                }, this)
            });

            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.action-item-file-uploader'),
                context: 'actionItems',
                contextId: this.model.id,
                canAddAnnotations: this.options.canEdit,
                onAnnotationChange: this.model.id > 0 ? null : (annotation) => {
                    this.changedAnnotations.merge(annotation);
                },
                mergeAnnotations: this.changedAnnotations,
                collection: this.model.attachments,
                includeProjectAttachments: true,
                previewImageDimension: 150,
                // includeProjectAttachments: true,
                canUpload: this.options.canUpload,
                canDelete: this.options.canEdit && this.options.isAdmin,
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.id > 0) {
                        attachment.set('isDeleted', true);
                    } else {
                        this.model.attachments.remove(attachment);
                    }
                    this.model.isDirty = true;
                    callback();
                }, this)
            });

            this.beforeUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.action-item-before-file-uploader'),
                context: 'actionItems',
                contextId: this.model.id,
                canAddAnnotations: this.options.canEdit,
                onAnnotationChange: this.model.id > 0 ? null : (annotation) => {
                    this.changedAnnotations.merge(annotation);
                },
                mergeAnnotations: this.changedAnnotations,
                collection: this.model.beforeAttachments,
                includeProjectAttachments: true,
                offsetTopText: true,
                previewImageDimension: 150,
                // includeProjectAttachments: true,
                canUpload: this.options.canUpload,
                canDelete: this.options.canEdit && this.options.isAdmin,
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.id > 0) {
                        attachment.set('isDeleted', true);
                    } else {
                        attachment.destroy();
                    }
                    this.model.isDirty = true;
                    callback();
                }, this)
            });

            this.afterUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.action-item-after-file-uploader'),
                context: 'actionItems',
                contextId: this.model.id,
                canAddAnnotations: this.options.canEdit,
                onAnnotationChange: this.model.id > 0 ? null : (annotation) => {
                    this.changedAnnotations.merge(annotation);
                },
                mergeAnnotations: this.changedAnnotations,
                collection: this.model.afterAttachments,
                includeProjectAttachments: true,
                offsetTopText: true,
                previewImageDimension: 150,
                // includeProjectAttachments: true,
                canUpload: this.options.canUpload,
                canDelete: this.options.canEdit && this.options.isAdmin,
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.id > 0) {
                        attachment.set('isDeleted', true);
                    } else {
                        attachment.destroy();
                    }
                    this.model.isDirty = true;
                    callback();
                }, this)
            });

            this.renderComments();
        }
    },
    renderStatus: function () {
        this.$('.action-item-status').css('background-color', this.model.getStatusColor());
        this.$('.action-item-status-name').html(this.model.getStatusName());
    },
    renderBallInCourt: function () {
        let $ballInCourt = this.$('.action-item-ball-in-court');
        if ((this.model.get('status') === PJQ.constants.actionItems.statuses.NEW || this.model.get('status') === PJQ.constants.actionItems.statuses.NOT_RESOLVED) && this.model.assignedTo != null) {
            this.renderSubTemplate(false, this.options.subTemplates.contactBadge, $ballInCourt,
                {
                    models: [this.model.assignedTo],
                    isReadOnly: true,
                    canEdit: false,
                    canView: false
                });
        } else if (this.model.get('status') === PJQ.constants.actionItems.statuses.WORK_COMPLETED) {
            $ballInCourt.html('<div class="text-muted font-weight-light mt-1">Project Managers</div>');
        } else {
            new PJQ.Alert($ballInCourt, {
                type: 'warning',
                text: 'The ball in court will set automatically'
            });
        }
    },
    renderCustomFields: function () {
        this.customFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
            el: this.$('.action-item-custom-fields'),
            collection: this.customFields,
            fieldValues: this.model.get('customFieldValues'),
            isEdit: this.options.canEdit
        });
    },
    distribute: function () {
        new PJQ.views.modals.YesNo({
            header: "Distribute Action Item?",
            body: 'Are you sure you want to distribute this action item?',
            onYes: () => {
                this.model.distribute(() => {
                    PJQ.notifications.notify.successNotify({
                        message: "Action Item successfully distributed"
                    });
                    this.render();
                });
            }
        });
    },
    exportPDF: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'actionitems',
                value: this.model.id
            },
            {
                endpoint: 'export'
            },
            {
                endpoint: 'pdf'
            }
        ]));
    },
    addComment: function () {
        let val = this.$('.item-new-comment').val().trim();
        if (_.size(val) === 0)
            return;

        let comment = new PJQ.models.actionItems.ActionItemComment({
            actionItemId: this.model.id,
            commentText: val,
            createdOn: new Date()
        });
        if (!this.model.isNew()) {
            comment.save(null, {
                success: _.bind(function () {
                    this.model.comments.add(comment);
                    this.renderComments();
                }, this)
            });
        } else {
            comment.createdBy = PJQ.app.session.user;
            this.model.comments.add(comment);
            this.renderComments();
        }

        this.$('.item-new-comment').val('');
    },
    renderComments: function () {
        this.renderSubTemplate(false, this.options.subTemplates.comments, this.$('.item-comments'), {
            comments: this.model.comments.models,
            canDelete: PJQ.app.session.hasPermission('actionItems.isAdmin') || (this.options.project && this.options.project.hasPermission('actionItems.isAdmin'))
        });
    },
    deleteComment: function (e) {
        let cid = $(e.currentTarget).data('cid'), commentId = $(e.currentTarget).data('commentId'),
            card = $(e.currentTarget).closest('div.card');
        new PJQ.views.BaseModal({
            header: "Confirm Delete Comment",
            body: "Are you sure you want to delete this comment?",
            isShowCancelButton: true,
            okButtonText: "Confirm",
            onOk: _.bind(function () {
                let comments = _.filter(this.model.comments.models, _.bind(function (comment, i) {
                    return (comment.cid === cid);
                }, this));

                if (_.size(comments) > 0) {
                    comments[0].set('deletedOn', new Date());
                    if (!comments[0].isNew()) {
                        comments[0].destroy();
                    }
                }

                _.each(this.model.get('comments'), _.bind(function (comment, i) {
                    if (comment.commentId === commentId) {
                        this.model.get('comments')[i].deletedOn = new Date();
                    }
                }, this));

                card.hide();
            }, this)
        });
    },
    markNotResolved: function () {
        new PJQ.views.BaseModal({
            header: "Confirm Status Change",
            body: "Are you sure you want to mark this Action Item as <span class='text-danger'>Not Resolved</span>?",
            isShowCancelButton: true,
            okButtonText: "Confirm",
            onOk: _.bind(function () {
                this.model.set('status', PJQ.constants.actionItems.statuses.NOT_RESOLVED);
                this.save();
            }, this)
        });
    },
    markWorkCompleted: function () {
        let workCompleteOverride = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.ACTION_ITEM_WORK_COMPLETED_STATUS_OVERRIDE);
        new PJQ.views.BaseModal({
            header: "Confirm Status Change",
            body: "Are you sure you want to mark this Action Item as <span class='text-primary'>" + (workCompleteOverride ? workCompleteOverride : "Work Completed") + "</span>?",
            isShowCancelButton: true,
            okButtonText: "Confirm",
            onOk: _.bind(function () {
                this.model.set('status', PJQ.constants.actionItems.statuses.WORK_COMPLETED);
                this.save();
            }, this)
        });
    },
    markResolved: function () {
        new PJQ.views.BaseModal({
            header: "Confirm Status Change",
            body: "Are you sure you want to mark this Action Item as <span class='text-success'>Resolved</span>?",
            isShowCancelButton: true,
            okButtonText: "Confirm",
            onOk: _.bind(function () {
                this.model.set('status', PJQ.constants.actionItems.statuses.RESOLVED);
                this.save();
            }, this)
        });
    },
    validate: function () {
        let isValid = true;

        PJQ.helpers.inputHelpers.setInputError(this.$('.item-title'), true);
        if (_.size(this.$('.item-title').val()) === 0) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError(this.$('.item-title'), false);
        }

        //todo: validate custom fields

        // display/clear banner on top of page
        if (!isValid) {
            new PJQ.Alert(this.$('.validation-error'), {
                type: 'danger',
                text: 'Required fields are empty'
            });

            window.scrollTo(0, 0);
        } else {
            this.$('.validation-error').empty();
        }

        return isValid;
    },
    viewEditHistory: function () {
        new PJQ.views.actionItems.EditHistoryModal({
            collection: this.model.editHistory
        });
    },
    viewNotificationHistory: function () {
        this.model.fetchNotifications(function (notifications) {
            new PJQ.views.notifications.NotificationHistory({
                collection: notifications
            });
        })
    },
    save: function () {
        if (this.isSaving) {
            return;
        }
        this.isSaving = true;

        this.model.set('groups', this.groupListInput.selectedGroups);
        if (!this.validate()) {
            this.isSaving = false;
            return;
        }

        if (this.fileUploader.isUploading()) {
            new PJQ.views.BaseModal({
                header: "Files Uploading",
                body: "You can't save while files are uploading"
            });
            this.isSaving = false;
            return;
        }

        let fnSaveAnnotations = (callback) => {
                if (_.size(this.changedAnnotations.models) === 0) {
                    callback();
                    return;
                }

                _.each(this.changedAnnotations.models, (annotation) => {
                    if (annotation.isNew()) {
                        annotation.set('contextId', this.model.id);
                    }
                });
                this.changedAnnotations.saveAll(() => {
                    if (this.options.isAdmin) {
                        this.model.set('isRead', true);
                    }
                    callback();
                });
            },
            isNew = this.model.isNew();
        if (this.model.hasChanged() || isNew) {
            this.model.save(null, {
                notify: true,
                success: () => {
                    fnSaveAnnotations(() => {
                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.model);
                        }

                        this.removeModal();
                    });
                }
            });
        } else {
            fnSaveAnnotations(() => {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                PJQ.notifications.notify.successNotify({
                    message: "RFI Saved Successfully"
                });

                this.removeModal();
            });
        }
    },
    close: function () {
        if (this.options.canEdit && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.onClose(this.model);
                    this.removeModal();
                }, this)
            });
        } else {
            this.onClose(this.model);
            this.removeModal();
        }
    },
    onDelete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this action item?",
            onDelete: _.bind(function () {
                if (this.options.onDelete) {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.actionItems.EditHistoryModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ACTIONITEMS, 'Modal-Action-Item-History'),
        minWidth: 700
    },
    afterRender: function () {
        this.$('.modal-header span').text(this.options.context + ' History');

        let columns = [
            {data: "createdOnDisplay", title: "Changed"},
            {data: "createdByDisplay", title: "Changed By"},
            {data: "attributes.fieldNameDisplay", title: "Field Name"},
            {data: "oldValueDisplay", title: "Old Value"},
            {data: "newValueDisplay", title: "New Value"}
        ];

        this.dataTable = this.$('.history-table').DataTable({
            data: this.collection.models,
            language: {
                zeroRecords: "No history found"
            },
            columns: columns,
            dom: '<"top"p>rt<"bottom"p><"clear">'
        });
    },
    events: {
        "click .history-close": "close"
    },
    close: function () {
        this.removeModal();
    }
});
